import React, { useState, useEffect } from "react";
import "./Timings.css";
import AOS from "aos";
import "aos/dist/aos.css";

export default function Timings() {

  useEffect(() => {
    AOS.init({
      duration: 900,
      easing: "ease-out-cubic",
      once: true,
    });
  }, []);

  const hours = [
    { day: "Monday", morning: "10:00 AM - 1:00 PM", evening: "5:00 PM - 8:00 PM" },
    { day: "Tuesday", morning: "10:00 AM - 1:00 PM", evening: "5:00 PM - 8:00 PM" },
    { day: "Wednesday", morning: "10:00 AM - 1:00 PM", evening: "5:00 PM - 8:00 PM" },
    { day: "Thursday", morning: "10:00 AM - 1:00 PM", evening: "5:00 PM - 8:00 PM" },
    { day: "Friday", morning: "10:00 AM - 1:00 PM", evening: "5:00 PM - 8:00 PM" },
    { day: "Saturday", morning: "10:00 AM - 1:00 PM", evening: "Closed" },
    { day: "Sunday", morning: "10:00 AM - 1:00 PM", evening: "5:00 PM - 8:00 PM" },
  ];

  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "Enquiry For",
    message: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const sendToWhatsApp = (e) => {
    e.preventDefault();
    const phoneNumber = "+918983501558"; // Your WhatsApp number
    const text = `📩 New Enquiry:\n\n👤 Name: ${form.name}\n📧 Email: ${form.email}\n📌 Subject: ${form.subject}\n💬 Message: ${form.message}`;
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(text)}`;
    window.open(url, "_blank");
  };

  return (
    <section className="timings-section" data-aos="fade-up">
      
      {/* Left - Opening Hours */}
      <div className="timings-box" data-aos="fade-right">
        <h2 className="timings-heading">Opening Hours</h2>
        
        <div className="hours-grid">
          {hours.map((item, idx) => (
            <div
              className="hours-card"
              key={idx}
              data-aos="zoom-in"
              data-aos-delay={idx * 120}
            >
              <h3>{item.day}</h3>
              <p><strong>Morning:</strong> {item.morning}</p>
              <p><strong>Evening:</strong> {item.evening}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Right - Enquiry Form */}
      <div className="enquiry-box" data-aos="fade-left">
        <h2 className="enquiry-heading">Send Enquiry</h2>

        <form className="enquiry-form" onSubmit={sendToWhatsApp}>
          <input
            type="text"
            name="name"
            placeholder="Name"
            value={form.name}
            onChange={handleChange}
            required
            data-aos="fade-up"
          />

          <input
            type="email"
            name="email"
            placeholder="Email address"
            value={form.email}
            onChange={handleChange}
            required
            data-aos="fade-up"
            data-aos-delay="100"
          />

          <select
            name="subject"
            value={form.subject}
            onChange={handleChange}
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <option>Enquiry For</option>
            <option>Appointment</option>
            <option>Services</option>
            <option>Other</option>
          </select>

          <textarea
            name="message"
            placeholder="Message"
            value={form.message}
            onChange={handleChange}
            data-aos="fade-up"
            data-aos-delay="300"
          />

          <label className="file-upload" data-aos="fade-up" data-aos-delay="350">
            <input type="file" hidden />
            +Add Attachment
          </label>

          <button
            type="submit"
            data-aos="fade-up"
            data-aos-delay="450"
          >
            Send Enquiry
          </button>
        </form>
      </div>
    </section>
  );
}
